<template>
  <v-col cols="aotu" xl="4" lg="4" md="5" sm="8">
    <template v-if="!flag_awaitOauth">
      <v-card :class="isOauth ? '' : 'pa-4'" style="transition: all ease 0.3s">
        <v-card-title>
          <h3 v-if="!isOauth">登陆</h3>
          <h5 v-else>登陆</h5>
        </v-card-title>
        <v-card-subtitle>
          <span>登陆MAKjustID</span>
        </v-card-subtitle>
        <v-card-text v-show="!isOauth">
          <v-alert
            v-if="isInvalid"
            type="error"
            color="error"
            border="left"
            outlined
            dense
            >
              错误的邮箱或密码
            </v-alert>
          <v-alert
            v-if="flag_noAccount"
            type="error"
            color="error"
            border="left"
            outlined
            dense
            >
              该第三方服务未绑定MAKjustID，请先登录或注册。
            </v-alert>
          <v-form ref="form" :disabled="isOauth">
            <v-text-field
              v-model="email"
              :rules="[rules.required, rules.emailReg]"
              label="E-mail"
              required
            ></v-text-field>
            <v-text-field
              v-model="password"
              :append-icon="pwdShow ? 'visibility' : 'visibility_off'"
              :rules="[rules.required, rules.pwdMin]"
              :type="pwdShow ? 'text' : 'password'"
              name="input-10-1"
              label="Password"
              hint="请输入密码"
              counter
              @click:append="pwdShow = !pwdShow"
              @keyup.enter="login()"
            ></v-text-field>
            <router-link to="findpwd">忘记密码？</router-link>
            <br />
            <router-link to="signup">注册MAKjust账户</router-link>
          </v-form>
        </v-card-text>
        <v-card-actions v-if="!isOauth">
          <v-spacer></v-spacer>
          <v-btn
            :disabled="isOauth"
            color="primary"
            style="padding: 0 42px"
            @click="login()"
            >登陆</v-btn
          >
        </v-card-actions>
      </v-card>
      <v-card
        :class="isOauth ? 'mt-4 pa-4' : 'mt-4'"
        style="transition: all ease 0.3s"
      >
        <v-card-title>
          <h3 v-if="isOauth">第三方登陆</h3>
          <h5 v-else>第三方登陆</h5>
          <v-spacer></v-spacer>
          <v-btn icon @click="isOauth = !isOauth">
            <v-icon>{{
              isOauth ? "keyboard_arrow_down" : "keyboard_arrow_up"
            }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle>
          <span>使用第三方账户服务来链接MAKjustID。</span>
        </v-card-subtitle>
        <v-card-actions v-if="isOauth">
          <v-row justify="center">
            <v-col
              cols="3"
              class="d-flex justify-center"
              v-for="(btn, i) in auths"
              :key="`_ACCOUNT-LOGIN-OAUTHBTN-${i}`"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :id="'authBtn_' + btn.type"
                    icon
                    large
                    v-on="on"
                    v-if="btn.type"
                    @click="authlogin(btn.type)"
                  >
                    <v-icon color="primary" large>{{ btn.icon }}</v-icon>
                  </v-btn>
                  <v-btn icon large v-on="on" v-else>
                    <v-icon large disabled>{{ btn.icon }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ btn.name }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </template>
    <v-card v-else>
      <v-card-title class="teal white--text">
        <v-progress-circular indeterminate color="white"></v-progress-circular>
        <span v-if="!flag_logined" class="ml-4">
          等待{{ oauthType }}登录结果...
        </span>
        <span v-else class="ml-4">
          登录成功！2秒后跳转至主页面...
        </span>
        </v-card-title>
      <v-card-text v-if="!flag_logined" class="pa-4">
        <span
          >如果您无法看见额外打开的子窗口，请<a href="">点击此处</a
          >来在新标签页进行登录。</span
        >
      </v-card-text>
      <v-card-actions v-if="!flag_logined">
        <v-spacer></v-spacer>
        <v-btn>取消</v-btn>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import mjp from "@/plugins/makjust";

export default {
  name: "LOGIN_Window_v1",
  data() {
    return {
      valid: false,
      email: "",
      password: "",
      pwdShow: false,
      isInvalid: false,
      isOauth: false,
      oauthType: "Null",
      flag_awaitOauth: false,
      flag_logined: false,
      flag_noAccount: false,
      rules: {
        required: (value) => !!value || "此项不能为空",
        pwdMin: (v) => v.length >= 6 || "这应该是一个至少6位的密码",
        emailReg: (v) =>
          /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
            v
          ) || "这不是一个正确的电子邮箱",
      },
      auths: [
        {
          name: "QQ登陆",
          icon: "iconfont icon-qq",
          type: "qq",
        },
        {
          name: "GitHub登陆",
          icon: "iconfont icon-github",
          type: "github",
        },
        {
          name: "微信登陆(敬请期待)",
          icon: "iconfont icon-wechat",
        },
      ],
    };
  },
  created() {
    if (localStorage.getItem("ms-user-sessionToken")) {
      this.$router.push("/");
      this.$store.commit("showSnackbar", {
        type: "error",
        text: "您已登陆。",
      });
    }
  },
  mounted() {
    if (this.$route.query.redirect) {
      this.$store.commit("showSnackbar", {
        type: "error",
        text: "请登陆后访问该页面。",
      });
    }
  },
  methods: {
    login() {
      mjp
        .login(this.email, this.password)
        .then((r) => {
          this.password = "";
          this.$store.dispatch("saveUserAsync", r.data);
          this.$store.commit("showSnackbar", {
            type: "success",
            text: "登陆成功",
          });
          this.$route.query.redirect
            ? this.$router.push(this.$route.query.redirect)
            : this.$router.push("/");
        })
        .catch((err) => {
          console.log(err);
          this.isInvalid = true;
          this.password = "";
          this.reset();
        });
    },
    reset() {
      this.$refs.form.resetValidation();
    },
    authlogin(type) {
      let _Url = "";
      if (type === "qq") {
        _Url =
          "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=101893306&response_type=token&scope=all&redirect_uri=https%3A%2F%2Fwww.makjust.com%2Faccount%2Foauth.php%2Fqq";
      }
      window.open(
        _Url,
        "QQ OAUTH",
        "width=900,height=450,screenX=420,screenY=120,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no"
      );
      this.oauthType = type.toUpperCase();
      this.flag_awaitOauth = true;
      //建立窗口回调监听
      window.addEventListener("message", this.awaitLogin);
    },
    awaitLogin(e) {
      //|--获取事件回调消息
      //验证回调来源
      if (e.origin === "https://graph.qq.com") {
        //QQ
        let data = JSON.parse(
          e.data.replace("1000:<.<<#:200:<.<<#:json:<.<<#:", "")
        ); //序列化data（QQ用户信息）
        QC.Login.getMe((openId, accessToken) => {
          mjp
            .authLogin({
              qq: {
                openid: openId,
                access_token: accessToken,
                expires_in: 7776000,
              },
            })
            .then((r) => {
              this.flag_awaitOauth = false
              this.flag_logined = false
              this.$store.dispatch("saveUserAsync", r.data);
              this.$store.commit("showSnackbar", {
                type: "success",
                text: "[OAuth]登陆成功",
              });
              setTimeout(() => {
                this.$route.query.redirect
                ? this.$router.push(this.$route.query.redirect)
                : this.$router.push("/");
              }, 200);
            })
            .catch((err) => {
              // console.log(err.response.data);
              if(err.response.data.code === 113){
                //未绑定
                this.$store.commit("showSnackbar", {
                  type: "error",
                  text: "该第三方服务未绑定账号。",
                });
                this.flag_noAccount = true;
                this.isOauth = false;
              }else{
                this.$store.commit("showSnackbar", {
                  type: "error",
                  text: "连接第三方服务时发生了错误。",
                });
              }
              this.flag_awaitOauth = false
              this.flag_logined = false
            });
        });
        // console.log(data)
      }
    },
  },
};
</script>